<template>
  <div
    v-omr-click-outside="hideDropDown"
    :class="[
      {
        'pointer-events-none': disabled,
      },
      fullWidth ? 'flex' : 'inline-flex',
      'flex-col',
    ]"
  >
    <slot name="activator" :open="handleActivatorClick" :show-drop-down="showDropDown"></slot>

    <div class="relative">
      <div
        data-testid="dropdown-panel"
        class="absolute z-40 rounded-sm shadow"
        :class="[
          innerClass,
          {
            'bg-surface': !dark,
            'bg-surface-inverse': dark,
            'pointer-events-none z-0 hidden': !showDropDown,
            'top-1': position === 'top',
            'bottom-0 -translate-y-1/3': position === 'bottom',
            'left-0': direction === 'left',
            'right-0': direction === 'right',
            'left-1/2 -translate-x-1/2': direction === 'middle',
          },
        ]"
      >
        <slot :close="hideDropDown"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default { name: 'DropDownSelect' }
</script>

<script setup lang="ts">
import { ref } from 'vue'

import { ClickOutside } from '@/directives/clickOutside'

const props = withDefaults(
  defineProps<{
    direction?: 'left' | 'right' | 'middle'
    position?: 'top' | 'bottom'
    innerClass?: string
    dark?: boolean
    disabled?: boolean
    fullWidth?: boolean
  }>(),
  {
    direction: 'left',
    position: 'top',
    innerClass: '',
    dark: false,
    disabled: false,
    fullWidth: false,
  },
)

const showDropDown = ref(false)

const vOmrClickOutside = ClickOutside

const handleActivatorClick = () => {
  if (props.disabled) return
  showDropDown.value = !showDropDown.value
}

const hideDropDown = () => {
  showDropDown.value = false
}
</script>
